export const PermissionLevels = {
  NewRequests: "Create New Requests/Modify Start Data",
  ApproveKickOff: "Kick-Off Approval"
};